import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCart, setCart } from "../../store/utils";
import { allOrders } from "../../CanteenUsers/OrderSlice";
import { getMenusDetails } from "../../CanteenUsers/MenusSlice";

const Menus = () => {
  const dispatch = useDispatch();
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const { menu, loading } = useSelector((state) => state.menus);
  const [cartItems, setCartItems] = useState(getCart());
  const id = localStorage.getItem("userId");
  const [tabs, setTabs] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    dispatch(allOrders())
  }, [dispatch])

  useEffect(() => {
    dispatch(getMenusDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (menu && (Array.isArray(menu.categories) || menu.combo_offer_categories)) {
      const allTabs = [
        ...(Array.isArray(menu.categories)
          ? menu.categories.map((cat) => ({
            id: cat.id,
            name: cat.name,
            type: "category",
            items: cat.items,
          }))
          : []),
        ...(menu.combo_offer_categories
          ? [
            {
              id: menu.combo_offer_categories.id,
              name: menu.combo_offer_categories.name,
              type: "combo",
              items: menu?.combo_offer_categories?.canteen_combo_offers_filtered?.map(
                (combo, i) => ({
                  id: i,
                  name: combo.combo_offer_name,
                  description: combo.combo_description,
                  items: combo.combo_items,
                  image: combo.image_url || null,
                  price: combo.price || 0,
                  stock_quantity: combo.stock_quantity ?? 100,
                  stock_available: combo.stock_quantity !== 0,
                })
              ),
            },
          ]
          : []),
      ];

      setTabs(allTabs);
      setSelectedCategory(allTabs[0]);
    }
  }, [menu]);


  useEffect(() => {
    if (menu.length > 0) {
      setSelectedCategoryId(menu[0].id);
    }
  }, [menu]);

  useEffect(() => {
    setCart(cartItems);
  }, [cartItems]);

  const handleAdd = (item) => {
    setCartItems((prev) => ({
      ...prev,
      [item.id]: { ...item, quantity: 1 },
    }));
  };

  const handleIncrease = (item) => {
    setCartItems((prev) => ({
      ...prev,
      [item.id]: { ...prev[item.id], quantity: prev[item.id].quantity + 1 },
    }));
  };

  const handleDecrease = (item) => {
    setCartItems((prev) => {
      const updated = { ...prev };
      if (updated[item.id].quantity === 1) {
        delete updated[item.id];
      } else {
        updated[item.id].quantity -= 1;
      }
      return updated;
    });
  };

  if (loading) return <p>Loading ...</p>
  return (
    <>
      <div className="flex flex-col bg-white h-[88vh] overflow-y-auto vertical">
        <div className="sticky top-0 z-20 bg-white">
          <div className="px-10 pt-4 ">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl font-bold text-G800">Menus</h1>
            </div>
            {/* categories */}
            <div className="flex gap-10 text-G800 font-semibold border-b border-G20 overflow-x-auto">
              {tabs.map((tab, index) => (
                <p
                  key={index}
                  onClick={() => setSelectedCategory(tab)}
                  className={`cursor-pointer py-2 text-nowrap ${selectedCategory?.id === tab.id && selectedCategory?.type === tab.type
                    ? "text-canteengreen border-b-2 border-canteengreen"
                    : ""
                    }`}
                >
                  {tab.name}
                </p>
              ))}
            </div>
          </div>
        </div>

        {/*category items data  */}
        <section className="px-10 z-10 mt-2">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold flex items-center gap-2 my-3">
              Choose Dishes
            </h2>
          </div>

          {selectedCategory?.type === "category" ? (
            selectedCategory.items.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {selectedCategory.items.map((dish, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow-md text-center border p-4"
                  >
                    <div className="flex justify-center py-3 items-center rounded-lg bg-canteencardcolor mb-3">
                      <img
                        src={`https://headquater.pixoatic.com${dish.image}`}
                        alt={dish.name}
                        loading="lazy"
                        className="w-32 h-32 rounded-full object-fill"
                      />
                    </div>
                    <div>
                      <p className="text-xl font-semibold mb-3 text-left mr-11">
                        {dish.name.replace(/\b\w/g, (char) => char.toUpperCase())}
                      </p>
                      <div className="flex justify-between items-center">
                        <p className="text-G800 text-[22px] font-bold mb-2">
                          <span className="text-canteengreen">₹ </span>{" "}
                          {Math.trunc(dish.price)}
                        </p>
                        {dish.stock_quantity === 0 ? (
                          <div className="text-red text-sm font-semibold px-3 py-1">
                            Out of Stock
                          </div>
                        ) : cartItems[dish.id]?.quantity > 0 ? (
                          <div className="flex items-center gap-3 border border-canteengreen text-G700 rounded-lg px-2 py-1 text-sm font-semibold">
                            <button onClick={() => handleDecrease(dish)}>-</button>
                            <span>{cartItems[dish.id].quantity}</span>
                            <button
                              onClick={() => handleIncrease(dish)}
                              disabled={
                                cartItems[dish.id].quantity >= dish.stock_quantity
                              }
                              className={
                                cartItems[dish.id].quantity >= dish.stock_quantity
                                  ? "text-gray-400 cursor-not-allowed"
                                  : ""
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleAdd(dish)}
                            className="bg-canteengreen text-white px-4 h-8 font-semibold rounded-lg text-xs"
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-G800 mt-8">
                No items available for this category.
              </p>
            )
          ) : selectedCategory?.type === "combo" ? (
            selectedCategory.items?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                {selectedCategory.items.map((combo, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg shadow-md text-center border p-4"
                  >
                    <div className="flex justify-center py-3 items-center rounded-lg bg-canteencardcolor mb-3">
                      <img
                        src={
                          combo.image
                            ? `https://headquater.pixoatic.com${combo.image}`
                            : "https://via.placeholder.com/100"
                        }
                        alt={combo.name}
                        loading="lazy"
                        className="w-32 h-32 rounded-full object-fill"
                      />
                    </div>
                    <div>
                      <p className="text-xl font-semibold mb-1 text-left">{combo.name}</p>
                      <p className="text-sm text-left text-gray-500 mb-2">{combo.description}</p>
                      <ul className="list-disc list-inside text-left text-sm text-gray-700 mb-3">
                        {combo.items?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                      <div className="flex justify-between items-center">
                        <p className="text-G800 text-[22px] font-bold mb-2">
                          <span className="text-canteengreen">₹ </span>{" "}
                          {Math.trunc(combo.price)}
                        </p>
                        {combo.stock_quantity === 0 ? (
                          <div className="text-red text-sm font-semibold px-3 py-1">
                            Out of Stock
                          </div>
                        ) : cartItems[combo.id]?.quantity > 0 ? (
                          <div className="flex items-center gap-3 border border-canteengreen text-G700 rounded-lg px-2 py-1 text-sm font-semibold">
                            <button onClick={() => handleDecrease(combo)}>-</button>
                            <span>{cartItems[combo.id].quantity}</span>
                            <button
                              onClick={() => handleIncrease(combo)}
                              disabled={
                                cartItems[combo.id].quantity >= combo.stock_quantity
                              }
                              className={
                                cartItems[combo.id].quantity >= combo.stock_quantity
                                  ? "text-gray-400 cursor-not-allowed"
                                  : ""
                              }
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleAdd(combo)}
                            className="bg-canteengreen text-white px-4 h-8 font-semibold rounded-lg text-xs"
                          >
                            ADD
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-G800 mt-8">
                No combo offers available.
              </p>
            )
          ) : null}

        </section>

      </div>
      {Object.keys(cartItems).length > 0 && (
        <Link to="/mainDashboard/createOrder" className="flex items-center gap-2 font-semibold ">
          <div className="fixed right-6 bottom-3 w-auto shadow-lg border border-canteencardcolor rounded-md bg-green text-white flex justify-between items-center px-6 py-3 z-10">
            <span>{Object.values(cartItems).reduce((acc, item) => acc + item.quantity, 0)} items</span>
            <div className="flex gap-3 ml-7"> Create Order</div>
          </div>
        </Link>
      )}
    </>
  );
};

export default Menus;
